module.exports = __webpack_public_path__ + "static/media/atendimento-em-casa.1a615907.webp";